import httpRequest from 'httpRequest'
import { OrderFulfillmentTypeContract } from 'models'

const orderFulfillmentTypesService = {
    getOrderFulfillmentTypes: () =>
        httpRequest.get<OrderFulfillmentTypeContract[]>(
            '/order-fulfillment-types',
            {},
        ),
}

export default orderFulfillmentTypesService
